import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'

import CustomModal from '../../Modal/CustomModal'

import './PrivacyAndPolicy.scss'

const PrivacyAndPolicy = ({ showModal, toggleModal, currentPath }: any) => {
  const {
    privacyAndPolicy: { containers }
  } = useStaticQuery(graphql`
    query {
      privacyAndPolicy {
        name
        containers {
          field_collections {
            fields {
              name
              value
            }
          }
        }
      }
    }
  `)

  const privacy = containers?.reduce((prev: any, container: any) => {
    const newObj: { [key: string]: string } = { ...prev }
    if (Array.isArray(container.field_collections)) {
      container.field_collections[0].fields?.forEach(({ value, name }: any) => {
        newObj[`${name}`] = value
      })
    }
    return newObj
  }, {})

  return (
    <>
      <CustomModal
        {...{
          showModal,
          toggleModal,
          height: '100%',
          width: '100%',
          footerLink: true,
          currentPath
        }}
      >
        <div className="privacy-and-policy">
          {!privacy['privacy-policy-title'] && !privacy.body && <h3 className="privacy-empty-text">No data to display.</h3>}

          <p className="title">{privacy['privacy-policy-title']}</p>
          <div className="content-wrapper" dangerouslySetInnerHTML={{ __html: privacy.body }} />
        </div>
      </CustomModal>
    </>
  )
}

export default PrivacyAndPolicy
